const RegisterForm = {
  fields: {
    email: {
      label: 'Email',
      placeholder: 'Email',
      dataTestId: 'email',
    },
    password: {
      label: 'Password',
      placeholder: 'Password',
      dataTestId: 'password',
    },
    password_confirmation: {
      label: 'Confirm Password',
      placeholder: 'Confirm Password',
      dataTestId: 'confirm-password',
    },
  },
  actions: {
    submitButton: {
      label: 'Continue',
      dataTestId: 'register-button',
    },
  },

  messages: {
    success: 'Registered successfully!',
  },
};

export default RegisterForm;
